"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsVIPCookie = exports.getIsVIPCookie = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _makeCookieName = require("./makeCookieName");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cookieName = (0, _makeCookieName.makeCookieName)("isVIP");

var getIsVIPCookie = function getIsVIPCookie() {
  var cookies = new _universalCookie["default"]();
  return cookies.get(cookieName);
};

exports.getIsVIPCookie = getIsVIPCookie;

var setIsVIPCookie = function setIsVIPCookie(value) {
  var cookies = new _universalCookie["default"]();
  cookies.set(cookieName, value);
  return cookies.get(cookieName);
};

exports.setIsVIPCookie = setIsVIPCookie;